export default ({ store, next }) => {
    if (!store.state.auth.user) {
        next("/auth/login")
        return false
    }
    next()
}
